// extracted by mini-css-extract-plugin
export var MainNav = "main-nav-module--MainNav--bd29e";
export var MainNav__item = "main-nav-module--MainNav__item--40a22";
export var MainNav__link = "main-nav-module--MainNav__link--6a7e8";
export var MainNav__linkActive = "main-nav-module--MainNav__link--active--e7f79";
export var MainNav__auth = "main-nav-module--MainNav__auth--faf96";
export var MainNav__authActive = "main-nav-module--MainNav__auth--active--50e3b";